import { TermSet } from '../../../../..';
import { LANDLORD_CLICKSTREAM_EVENTS, RENTER_CLICKSTREAM_EVENTS } from '../../../clickstream/events';
import { TermType } from '@zg-rentals/ts-id-verification-client';
import type { TrackEvent } from '../../../clickstream/events';

export function trackTermView(termSet: TermSet, termType: TermType, trackEvent: TrackEvent) {
  const isLandlord = termSet === TermSet.LandlordScreening;
  switch (termType) {
    case TermType.EXPERIAN_TAC: {
      const clickstreamEvent = isLandlord
        ? LANDLORD_CLICKSTREAM_EVENTS.termView.experianTac
        : RENTER_CLICKSTREAM_EVENTS.termView.experianTac;
      trackEvent(clickstreamEvent);
      break;
    }
    case TermType.EXPERIAN_PRIVACY_POLICY: {
      const clickstreamEvent = isLandlord
        ? LANDLORD_CLICKSTREAM_EVENTS.termView.experianPrivacyPolicy
        : RENTER_CLICKSTREAM_EVENTS.termView.experianPrivacyPolicy;
      trackEvent(clickstreamEvent);
      break;
    }
    case TermType.CIC_TAC: {
      trackEvent(LANDLORD_CLICKSTREAM_EVENTS.termAgree.cicTac);
      break;
    }
  }
}

export function trackTermAcceptance(termSet: TermSet, termType: TermType, trackEvent: TrackEvent) {
  const isLandlord = termSet === TermSet.LandlordScreening;
  switch (termType) {
    case TermType.EXPERIAN_TAC: {
      const clickstreamEvent = isLandlord
        ? LANDLORD_CLICKSTREAM_EVENTS.termAgree.experianTac
        : RENTER_CLICKSTREAM_EVENTS.termAgree.experianTac;
      trackEvent(clickstreamEvent);
      break;
    }
    case TermType.EXPERIAN_PRIVACY_POLICY: {
      const clickstreamEvent = isLandlord
        ? LANDLORD_CLICKSTREAM_EVENTS.termAgree.experianPrivacyPolicy
        : RENTER_CLICKSTREAM_EVENTS.termAgree.experianPrivacyPolicy;
      trackEvent(clickstreamEvent);
      break;
    }
    case TermType.CIC_TAC: {
      const clickstreamEvent = isLandlord
        ? LANDLORD_CLICKSTREAM_EVENTS.termAgree.cicTac
        : RENTER_CLICKSTREAM_EVENTS.termAgree.cicTac;
      trackEvent(clickstreamEvent);
      break;
    }
    case TermType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER:
      trackEvent(RENTER_CLICKSTREAM_EVENTS.termAgree.experianCicWrittenConsentRenter);
      break;
    case TermType.CIC_CONFIRMATION_RENTER:
      trackEvent(RENTER_CLICKSTREAM_EVENTS.termAgree.cicConfirmationRenter);
      break;
    case TermType.EXPERIAN_WRITTEN_CONSENT_LANDLORD:
      trackEvent(LANDLORD_CLICKSTREAM_EVENTS.termAgree.experianWrittenConsentLandlord);
      break;
  }
}
